const Element = require('./element');
const ElementCreator = require('../../creators/abstract/element.js');

module.exports = Graphic;

function Graphic () {}
Graphic.prototype = new Element();
Graphic.prototype.constructor = Graphic;
Graphic.prototype.getSmartAssetsData = ElementCreator.prototype.getSmartAssetsData;
